import React, { useState } from 'react'
import { Button } from '../ui'
import { SubgoalCard } from './SubgoalCard.jsx'
import { SubgoalForm } from './SubgoalForm.jsx'

export function SubgoalsSection({
  goalId,
  subgoals = [],
  onCreateSubgoal,
  onDeleteSubgoal,
  onSetSubgoalStatus,
  onUpdateKpi,
  onToggleDeliverable,
  onAddDeliverable,
  onRemoveDeliverable,
  onToggleMilestone,
  onAddMilestone,
  onRemoveMilestone,
  onUpdateCriteria,
  onUpdateDeadline,
  onUpdateNotes,
  onUpdateTitle,
  parentTimeHorizon = null,
}) {
  const [showForm, setShowForm] = useState(false)

  async function handleCreate(input) {
    await onCreateSubgoal?.(goalId, input)
    setShowForm(false)
  }

  function callbacksFor(sg) {
    return {
      onSetStatus: (status) => onSetSubgoalStatus?.(goalId, sg.subgoalId, status),
      onUpdateKpi: (val) => onUpdateKpi?.(goalId, sg.subgoalId, val),
      onToggleDeliverable: (delId) => onToggleDeliverable?.(goalId, sg.subgoalId, delId),
      onAddDeliverable: (text) => onAddDeliverable?.(goalId, sg.subgoalId, text),
      onRemoveDeliverable: (delId) => onRemoveDeliverable?.(goalId, sg.subgoalId, delId),
      onToggleMilestone: (msId) => onToggleMilestone?.(goalId, sg.subgoalId, msId),
      onAddMilestone: (title) => onAddMilestone?.(goalId, sg.subgoalId, title),
      onRemoveMilestone: (msId) => onRemoveMilestone?.(goalId, sg.subgoalId, msId),
      onUpdateCriteria: (text) => onUpdateCriteria?.(goalId, sg.subgoalId, text),
      onUpdateDeadline: (date) => onUpdateDeadline?.(goalId, sg.subgoalId, date),
      onUpdateNotes: (notes) => onUpdateNotes?.(goalId, sg.subgoalId, notes),
      onUpdateTitle: (title) => onUpdateTitle?.(goalId, sg.subgoalId, title),
      onDelete: () => onDeleteSubgoal?.(goalId, sg.subgoalId),
    }
  }

  return (
    <div style={styles.section}>
      <div style={styles.header}>
        <span style={styles.label}>Sub-goals</span>
        <span style={styles.count}>{subgoals.length}</span>
        {!showForm && (
          <span style={{ marginLeft: 'auto' }}>
            <Button size="sm" variant="secondary" onClick={() => setShowForm(true)}>
              + Add sub-goal
            </Button>
          </span>
        )}
      </div>

      {showForm && (
        <div style={styles.formWrapper}>
          <SubgoalForm onSave={handleCreate} onCancel={() => setShowForm(false)} parentTimeHorizon={parentTimeHorizon} />
        </div>
      )}

      <div style={styles.list}>
        {subgoals.map((sg) => (
          <SubgoalCard key={sg.subgoalId} subgoal={sg} editable {...callbacksFor(sg)} />
        ))}
      </div>

      {subgoals.length === 0 && !showForm && (
        <p style={styles.empty}>No sub-goals yet. Add one to track concrete work.</p>
      )}
    </div>
  )
}

const styles = {
  section: { display: 'flex', flexDirection: 'column', gap: '10px' },
  header: { display: 'flex', alignItems: 'center', gap: '8px' },
  label: {
    fontSize: '10px',
    fontWeight: 700,
    color: 'var(--text-secondary)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  count: { fontSize: '10px', color: 'var(--text-secondary)' },
  formWrapper: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '10px',
    padding: '16px',
  },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  empty: { fontSize: '12px', color: 'var(--text-secondary)', margin: 0 },
}
